// eslint-disable-next-line import/no-anonymous-default-export
export default {
  OnlineScreen: 'HitPaw Online Screen Recorder',
  RecordScreenWithAudio:
    'Record entire screen, an application window, or browser tab with audio',
  ScreenOnly: 'Screen Only',
  ScreenAndCam: 'Screen & Webcam',
  Microphone: 'Microphone',
  SystemAudio: 'System Audio',
  StartRecording: 'Start Recording',
  NoAudioAndTryAgain:
    'No audio source available. Please follow <1><0>the instructions</0></1> below and try again.',
  TheInstruction: 'the instructions',
  AccessMicrophone:
    'online.hitpaw.com need to access your Microphone to record audio, please click Allow!',
  BestScreenRecorderSoftware:
    'Best Screen Recorder & Free Video Streaming Software',
  CaptureAnythingOnScreen:
    'Capture and record your websites, lectures, video calls, and anything on screen',
  RecordToShare: 'Record your gameplay highlights to share with friends',
  StreamOnFackbook: 'Stream on Facebook, YouTube, Twitch, etc. like a pro',
  BringMagic: 'Bring magic virtual webcam to live streams and video chats',
  StepOne: 'Step1: Choose the screen you want to record.',
  StepTwo: 'Step2: Choose the screen you want to record.',
  StepThree: 'Step3: Click“Share system audio”.',
  StepFour: 'Step2: Click “Share”and start recording.',
  GrantPermission:
    'Please grant permission for screen recording and try again.',
  RecordingProgress: 'Recording in progress...',
  MoreOptions: 'More Recording Options:',
  Pause: 'Pause',
  Continue: 'Continue',
  Stop: 'Stop',
  Webcam: 'Webcam',
  GreenScreenAndChangeBackground: 'Green Screen & Change Background',
  StreamToYouTube: 'Stream to Facebook, Twitch, YouTube, etc.',
  ScheduleRecording: 'Schedule Recording',
  NewRecording: 'New Recording',
  ExportToMp4: 'Export to MP4',
  AddWatermark: 'Add Watermark',
  ChangeSpeed: 'Change Speed',
  CutAndTrim: 'Cut & Trim',
  '120XDownload': '120X Faster Video Converter & HD Video Downloader',
  CovertAudioFormats: 'Convert video and audio files to 1000+ formats',
  DownloadVideoFromWebsites:
    'Download and save videos from 10000+ video sharing websites',
  BatchConvertImageAndGif: 'Batch convert images and create GIFs from videos',
  RichEdingingFeatures:
    'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  BestVideoEditor: 'Best Video Editor Designed for Multi-Purposes',
  MakeSimpleEdits:
    'An award-winning video editor to make complex edits simple.',
  BeyondImaginationMaterials:
    'Varous built-in and online materials beyond imagination.',
  AqualityVideoMaker:
    'A quality-oriented video maker to export and share 1080P/4K videos completely free.',
  WorkOnAnywhere:
    'Works well and safely on any PC without affecting its performance.',
  RecordCompleted: 'Recording Completed',
  Download: 'Download',
  YouMayNeed: 'You May Need',
  TryItFree: 'Try It Free',
  AlreadyHaveAccount: 'Already have account?',
  LoginNow: 'Login Now',
  exceedTenMin: 'Time is up for the 10-minute recording.',
  UpgradeToRecord: 'Upgrade to continue recording.',
  ScreenProFeature: 'HitPaw Online Screen Recorder Pro features',
  FreeScreenAccount:
    'Free account has only <1><0>10</0></1> minutes of recording time.',
  BuyNow: 'Buy Now',
  DownloadMp4: 'Download As MP4',
  FreeDownload: 'Free Download',
  DownloadTenMin: 'Download 10 Mins',
  FullVideo: 'Full Video',
  FormatMp4: 'Download As MP4',
  Downloading: 'Downloading...',
  DownloadFailed: 'Failed to download, please try again.',
  DownloadSuccess: 'Download Successfully!',
  Exceed100MDownloadConvert:
    'Video size cannot exceed 100MB for downloading video in MP4 format. Download HitPaw Video Converter for more features.',
  Exceed30Min:
    'Video duration cannot exceed 30 minutes for downloading video in MP4 format. Download HitPaw Video Converter for more features.',
  Week: 'Week',
  BilledMonthly: 'Billed Monthly',
  ConvertText1:
    'Download Desktop Version to Batch Process Large Files With NO Size Limit',
  ConvertText2:
    'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  ConvertText3:
    'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  ConvertText4:
    'Convert Apple Music to MP3 with DRM removed (Windows version only)',
  TenMinUp: 'Time is up for the 10-minute recording.',
  UpgradeMore: 'Upgrade to continue recording.',
  NoRecordLimit: 'No time limit for screen recording',
  NoRecordNumLimit: 'No limit on the number of recording',
  MonthOff: '60% OFF',
  YearOff: '80% OFF',
  UpgradeNow: 'Upgrade Now',
  CheckConnect: 'Check your connection and try again.',
};
